import CustomIcon from '@Assets/images/icons';
import { faCheck, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';
import PasswordMeter from './components/PasswordMeter';
import { ContainerIcon, ContainerPassword, Label, TextMuted } from './styled';
import { PasswordProps } from './types';
import { usePassword } from './usePassword';
import { ErrorText } from '@Pages/Auth/components/styled';

function PasswordAndConfirm<
	T extends { password: string; confirmpassword: string }
>({ formik }: PasswordProps<T>) {
	const {
		formatMessage,
		showPassword,
		strenghOfPassword,
		textOfStrengthOfPassword,
		showPasswordConfirm,
		setShowPassword,
		setShowPasswordConfirm,
	} = usePassword({ formik });

	return (
		<ContainerPassword>
			<div
				className="mb-10 fv-row position-relative"
				data-kt-password-meter="true"
				id="kt_password_meter_control"
			>
				<div className="mb-1">
					<Label className="form-label fw-bolder text-dark fs-6">
						{formatMessage({ id: 'AUTH.PASSWORD' })}
					</Label>
					<div className="position-relative mb-3 ">
						<input
							type={showPassword ? 'text' : 'password'}
							autoComplete="new-password"
							{...formik.getFieldProps('password')}
							className={clsx(
								'form-control form-control-lg form-control-solid pr-100px '
							)}
						/>

						{formik.touched.password && !formik.errors.password && (
							<FontAwesomeIcon
								icon={faCheck}
								color="#50CD89"
								style={{
									height: '1.929rem',
									width: '1.929rem',
									marginRight: '0.357rem',
									marginTop: '-0.143rem',
								}}
								className={clsx(`position-absolute top-0 end-0 pt-4 pe-12  `)}
							/>
						)}
						{formik.touched.password && formik.errors.password && (
							<ContainerIcon>
								<FontAwesomeIcon
									icon={faExclamation}
									color="#f1416c"
									style={{
										height: '1.071rem',
										width: '1.214rem',
										display: 'flex',
										justifyContent: 'center',
									}}
								/>
							</ContainerIcon>
						)}
						<CustomIcon
							icon={showPassword ? 'eyeOpen' : 'eyePassword'}
							onClick={() => setShowPassword(!showPassword)}
							className={clsx(
								`position-absolute top-0 end-0 pt-4 pe-5  bg-transparent btn`
							)}
						/>
					</div>
					{/* begin::Meter */}
					<PasswordMeter strength={strenghOfPassword} />
					{/* end::Meter */}
				</div>
				<TextMuted>
					{textOfStrengthOfPassword === null
						? formatMessage({ id: 'AUTH.VALIDATE.PASSWORDMUSTCONTAIN' })
						: textOfStrengthOfPassword}
				</TextMuted>

				{formik.touched.password && formik.errors.password && (
					<ErrorText>
						{formatMessage({ id: formik.errors.password.toString() })}
					</ErrorText>
				)}
			</div>
			<div className="fv-row mb-5">
				<Label className="form-label fw-bolder text-dark fs-6">
					{formatMessage({ id: 'AUTH.REGISTER.STEP2.5' })}
				</Label>

				<div className="position-relative mb-3">
					<input
						type={showPasswordConfirm ? 'text' : 'password'}
						{...formik.getFieldProps('confirmpassword')}
						className={clsx(
							'form-control form-control-lg form-control-solid pr-100px place-holder-control'
						)}
					/>
					<div onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}>
						{formik.touched.confirmpassword &&
							!formik.errors.confirmpassword && (
								<FontAwesomeIcon
									icon={faCheck}
									color="#50CD89"
									style={{
										height: '1.929rem',
										width: '1.929rem',
										marginRight: '0.357rem',
										marginTop: '-0.143rem',
									}}
									className={clsx(`position-absolute top-0 end-0 pt-4 pe-12  `)}
								/>
							)}
						{formik.touched.confirmpassword &&
							formik.errors.confirmpassword && (
								<ContainerIcon>
									<FontAwesomeIcon
										icon={faExclamation}
										color="#f1416c"
										style={{
											height: '1.071rem',
											width: '1.214rem',
											display: 'flex',
											justifyContent: 'center',
										}}
									/>
								</ContainerIcon>
							)}

						<CustomIcon
							icon={showPasswordConfirm ? 'eyePassword' : 'eyeOpen'}
							onClick={() => setShowPassword(!showPassword)}
							className={clsx(
								`position-absolute top-0 end-0 pt-4 pe-5  bg-transparent btn`
							)}
						/>
					</div>
					{formik.touched.confirmpassword && formik.errors.confirmpassword && (
						<ErrorText>
							{formatMessage({ id: formik.errors.confirmpassword.toString() })}
						</ErrorText>
					)}
				</div>
			</div>
			{/* end::Form group */}
		</ContainerPassword>
	);
}

export default PasswordAndConfirm;
